import { useQuery } from '@tanstack/react-query';
import { ApiConfig } from '@/config/api.config';
import { useAxiosAuth } from '@/hooks/useAxiosAuth';
import type { IntegrationMessageTypesResponseDto } from './integration-message.types';

export const useIntegrationMessageTypesApi = () => {
    const axiosInstance = useAxiosAuth();

    const { data, isLoading } = useQuery<IntegrationMessageTypesResponseDto>({
        queryKey: [ApiConfig.queries.superAdmin.integrationMessages.messageTypes.queryKeys.get],
        queryFn: async () => {
            const response = await axiosInstance.get<IntegrationMessageTypesResponseDto>(
                ApiConfig.queries.superAdmin.integrationMessages.messageTypes.endpoints.get,
            );
            return response.data;
        },
    });

    return { messageTypes: data, isLoadingMessageTypes: isLoading };
};
